module.exports = __webpack_public_path__ + "img/welc_temp_img.34eff8a0.jpg";